import * as React from 'react'

export const ColouredImportIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18 4.5V15.5M12.8 10.8L18 16L23.2 10.8M3 17.5V24.5C3 26.7573 4.8296 28.5869 7.08696 28.5869H28.913C31.1704 28.5869 33 26.7573 33 24.5V17.5"
        stroke="url(#paint0_linear_975_34706)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_975_34706"
          x1="18"
          y1="28.5869"
          x2="18"
          y2="4.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C57FF" />
          <stop offset="1" stopColor="#48A1FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
